import styled from 'styled-components';

export const Title = styled.h3`
  display: flex;
  gap: 8px;
  align-items: center;
  overflow: hidden;
  color: ${({ theme }) => theme.colors.black9};
  text-overflow: ellipsis;
  font-family: ${({ theme }) => theme.fontFamily.primary};
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
`;

export const MaxHeightUl = styled.ul`
  max-height: 200px;
  overflow-y: auto;
  padding-left: 20px;
  margin: 0 !important;
`;

export const ActivityItem = styled.li`
  cursor: pointer;
  font-family: ${({ theme }) => theme.fontFamily.primary};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export const SyncedWarning = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.red6};
`;
